/* Measure real prices (including sale/currency text), not a viewport guess.
 * No click/key handlers: the theme's existing card link remains the only action.
 * Custom-element lifecycle covers Shopify's filtered/paginated grid replacements.
 */
(() => {
  if (customElements.get('bw-card-personalize-row')) return;
  class CardPersonalizeRow extends HTMLElement {
    connectedCallback() {
      if (!this.closest('.bw-personalize-card') || this.observer || !window.ResizeObserver) return;
      const price = this.querySelector('.price');
      const label = this.querySelector('.bw-card-personalize-label');
      const dot = this.querySelector('.bw-card-personalize-dot');
      if (!price || !label || !dot) return;
      const fit = () => {
        const gap = parseFloat(getComputedStyle(this).columnGap) || 0;
        const needed = Math.max(price.scrollWidth, price.getBoundingClientRect().width)
          + Math.max(label.scrollWidth, label.getBoundingClientRect().width)
          + dot.getBoundingClientRect().width + 2 * gap;
        const fits = needed <= this.clientWidth - 1;
        if (fits !== this.classList.contains('is-inline')) this.classList.toggle('is-inline', fits);
      };
      this.observer = new ResizeObserver(fit);
      [this, price, label].forEach(element => this.observer.observe(element));
      fit();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }
  }
  customElements.define('bw-card-personalize-row', CardPersonalizeRow);
})();
